/**
 * Maths with Manoj Secure QR Utility
 * This utility handles encryption and decryption of student QR codes
 * to prevent manual generation by online tools.
 */

const PREFIX = "SM_ID_V1_";

/**
 * Encrypts data for QR code generation
 * @param {Object|string} data 
 * @returns {string}
 */
export const encryptQR = (data) => {
    try {
        const str = typeof data === 'string' ? data : JSON.stringify(data);
        // Base64 encode the string
        const base64 = btoa(unescape(encodeURIComponent(str)));
        // Simple scrambling: Reverse + Custom Prefix
        const scrambled = base64.split('').reverse().join('');
        return `${PREFIX}${scrambled}`;
    } catch (e) {
        console.error("Encryption failed", e);
        return "";
    }
};

/**
 * Decrypts data from a scanned QR code
 * @param {string} encryptedData 
 * @returns {Object|null}
 */
export const decryptQR = (encryptedData) => {
    if (!encryptedData || !encryptedData.startsWith(PREFIX)) {
        return null;
    }

    try {
        // Remove prefix and unscramble (reverse back)
        const payload = encryptedData.replace(PREFIX, "").split('').reverse().join('');
        // Decode base64
        const decoded = decodeURIComponent(escape(atob(payload)));
        return JSON.parse(decoded);
    } catch (e) {
        console.error("Decryption failed", e);
        return null;
    }
};
